import { useSearchParams } from "react-router-dom";

/** True when the Andon page URL includes `?advanced=true`. */
export function useAndonAdvancedFeatures(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get("advanced") === "true";
}
